import { render, staticRenderFns } from "./FreightDetail.vue?vue&type=template&id=75de652b&scoped=true&"
import script from "./FreightDetail.vue?vue&type=script&lang=js&"
export * from "./FreightDetail.vue?vue&type=script&lang=js&"
import style0 from "./FreightDetail.vue?vue&type=style&index=0&id=75de652b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75de652b",
  null
  
)

export default component.exports